<script>
  import { onDestroy } from 'svelte';
  import { cart } from './storage.js';
  import { updateCartItem, removeCartItem, handleResponse, showErrors } from './requests.js';

  let { item, onrefresh } = $props();
  let thumbnail = $derived(item.image ? `${item.image}/200/200` : '/img/thumbnail.svg');

  let quantity = $derived(Number(item.quantity))
  let solitary = $derived(['Digital', 'Appointment'].includes(item.type));
  let updating = $state(false);

  const mediaQuery = window.matchMedia('(max-width: 767px)');
  const handleMediaChange = event => isMobile = event.matches;

  let isMobile = $state(mediaQuery.matches);

  mediaQuery.addEventListener('change', handleMediaChange);
  onDestroy(() => mediaQuery.removeEventListener('change', handleMediaChange));

  const plus = () => {
    if (updating) return;
    updating = true;
    updateCartItem($cart.id, item.id, {token: $cart.token, quantity: quantity + 1})
    .then(handleResponse)
    .then(body => onrefresh?.())
    .catch(showErrors)
    .finally(() => updating = false)
  }

  const minus = () => {
    if (updating) return;
    updating = true;
    updateCartItem($cart.id, item.id, {token: $cart.token, quantity: quantity - 1})
    .then(handleResponse)
    .then(body => onrefresh?.())
    .catch(showErrors)
    .finally(() => updating = false)
  }

  const remove = () => {
    if (updating) return;
    updating = true;
    removeCartItem($cart.id, item.id, $cart.token)
    .then(handleResponse)
    .then(body => onrefresh?.())
    .catch(showErrors)
    .finally(() => updating = false)
  }

</script>

<div class="IN1_cart__item" class:updating class:solitary>
  <div class="IN1_cart__item-image">
    <img src="{thumbnail}" alt="Zdjęcie produktu">
  </div>

  <div class="IN1_cart__item-name">
    {item.name}
    {#if item.type == 'Appointment'}
      <span class="IN1_subtitle">{item.panacea_data?.outline}</span>
    {/if}
  </div>

  
  
  {#if !solitary}
  <div class="IN1_cart__item-quantity">
    <div class="quantity">
      <button
        type="button"
        onclick={() => {
          if (quantity == 1 && isMobile) {
            if (window.confirm('Usunąć produkt z koszyka?')) remove();
          } else if (quantity == 1) {
            remove();
          } else {
            minus();
          }
        }}
        class="quantity__manipulate" 
        class:disabled={item.quantity == 1 && !isMobile}
        disabled={updating}
      >-</button>
      <div class="quantity__value">{ parseFloat(item.quantity).toFixed() } szt.</div>
      <button type="button" class="quantity__manipulate" onclick={plus} disabled={updating}>+</button>
    </div>

    <span class="IN1_cart__item-price-single">{item.price_with_currency} / szt.</span>
  </div>
  {/if}

  <div class="IN1_cart__item-price">
    <div class="IN1_cart__item-price-total">{item.total_price_with_currency}</div>
  </div>

  <div class="IN1_cart__item-remove">
    <button
      type="button"
      class="item_remove"
      onclick={remove}
      disabled={updating}
      title="Usuń produkt z koszyka"
      aria-label="Usuń produkt z koszyka"
    >
      <span class="item_remove__word">usuń</span>
      <svg
        class="item_remove__glyph"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M4 7h16M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7M6.5 7l.9 12.1a1.5 1.5 0 0 0 1.5 1.4h6.2a1.5 1.5 0 0 0 1.5-1.4L17.5 7M10 11v5.5M14 11v5.5" />
      </svg>
    </button>
  </div>
</div>


<style>
  .IN1_cart__item {
    border-bottom: 1px solid #e0e0e0;
    display: grid;
    grid-template-areas:
      "image name price"
      "image quantity remove";
    grid-template-columns: 120px auto max-content;
    grid-template-rows: max-content auto;
    width: 100%;
    grid-column-gap: 30px;
    grid-row-gap: 15px;
    padding: 20px 0;
  }

  .IN1_cart__item:first-of-type {
    padding-top: 0;
  }

  .IN1_cart__item.updating {
    opacity: 0.5;
    pointer-events: none;
  }

  .IN1_cart__item-image {
    grid-area: image;
  }

  .IN1_cart__item-image img {
    max-width: 100%;
    display: block;
  }

  .IN1_cart__item-name {
    grid-area: name;
    align-self: start;
    font-weight: bolder;
    font-size: 1.2em;
  }

  .IN1_subtitle {
    display: block;
    font-size: 0.8em;
    font-weight: bold;
  }

  .IN1_cart__item-quantity {
    grid-area: quantity;
  }

  .IN1_cart__item-price {
    grid-area: price;
    align-self: start;
    font-weight: 600;
    font-size: 1.2em;
    text-align: right;
  }

  .IN1_cart__item-remove {
    grid-area: remove;
    align-self: end;
    text-align: right;
  }

  .quantity {
    display: inline-grid;
    grid-template-columns: 30px minmax(60px, auto) 30px;
    border: 1px solid #cccccc;
    border-radius: 3px;
    align-items: center;
    font-size: 0.9em;
  }

  .quantity__value {
    border-left: 1px solid #cccccc;
    border-right: 1px solid #cccccc;
    padding: 2px 5px;
    text-align: center;
  }

  .quantity__manipulate {
    text-decoration: none;
    transition: background 0.2s ease-in-out;
    font-weight: bold;
    padding: 2px 5px;
    text-align: center;
    border: 0;
    height: 100%;
    color: #5D6AC5;
    cursor: pointer;
  }

  .quantity__manipulate:not(.disabled):hover {
    background-color: #cccccc;
  }

  .quantity__manipulate.disabled {
    color: #cccccc;
    cursor: default;
    pointer-events: none;
  }

  .item_remove {
    position: relative;
    background: none;
    border: 0;
    padding: 0;
    color: inherit;
    font: inherit;
    font-size: 0.8em;
    line-height: 1;
    cursor: pointer;
    opacity: 0.8;
    transition: opacity 0.2s ease-in-out;
  }

  /* invisible 44px tap target, costs no layout space */
  .item_remove::after {
    content: '';
    position: absolute;
    inset: -12px -16px;
  }

  .item_remove:hover,
  .item_remove:active {
    opacity: 1;
  }

  .item_remove:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 3px;
    opacity: 1;
  }

  .item_remove__glyph {
    display: none;
  }

  .IN1_cart__item-price-single {
    font-size: 0.9em;
    margin-left: 10px;
  }

  @media (max-width: 767px) {
    .IN1_cart__item {
      grid-template-columns: 70px 1fr auto;
      grid-template-areas:
        "image price    remove"
        "image name     name"
        "image quantity quantity";
      grid-column-gap: 15px;
      grid-row-gap: 2px;
      border-bottom: 0;
    }

    .IN1_cart__item.solitary {
      grid-template-areas:
        "image price remove"
        "image name  name";
    }

    .IN1_cart__item-price {
      align-self: start;
      text-align: left;
      font-size: 1.05em;
      font-weight: 600;
      line-height: 1.2;
    }

    .IN1_cart__item-name {
      align-self: start;
      font-size: 0.95em;
      font-weight: 400;
      line-height: 1.35;
    }

    .IN1_subtitle {
      margin-top: 2px;
      font-size: 0.85em;
      font-weight: 400;
      opacity: 0.7;
    }

    .IN1_cart__item-quantity {
      align-self: center;
    }

    .IN1_cart__item-remove {
      align-self: center;
    }

    .quantity {
      font-size: 0.85em;
    }

    .IN1_cart__item-price-total {
      display: inline;
    }

    .IN1_cart__item-price-single {
      display: none;
    }

    .item_remove {
      opacity: 0.55;
    }

    .item_remove__word {
      display: none;
    }

    .item_remove__glyph {
      display: block;
      width: 20px;
      height: 20px;
    }
  }
</style>
